import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { Field } from 'formik';
import { memo } from 'react';

export const ResourceTypeSelect = memo(({ resourceTypes }: { resourceTypes: string[] }) => {
    return (
        <Field name="resourceType">
            {({ field }) => (
                <FormControl sx={{ width: '200px' }}>
                    <InputLabel id="select-label">Resource Type</InputLabel>
                    <Select labelId="select-label" id="select-type" label="Resource Type" {...field}>
                        {resourceTypes.map(type => (
                            <MenuItem sx={{ color: 'white' }} key={type} value={type}>
                                {type}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            )}
        </Field>
    );
});
